<template>
  <svg
    class="inline-block"
    fill="currentColor"
    :viewBox="viewBox"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <use :href="`#${src}`" />
  </svg>
</template>

<script>
export default {
  name: 'Icon',

  props: {
    src: {
      type: String,
      required: true,
    },

    proportions: {
      type: String,
      required: false,
      default: 'square',
    },
  },

  computed: {
    viewBox() {
      switch (this.proportions) {
        case 'square':
          return '0 0 24 24';

        case 'rectangle':
          return '0 0 16 9';

        default:
          return '0 0 24 24';
      }
    },
  },
};
</script>
